<template>
    <div class="context">
        <component :is="component_id"
                   @changeTopTab="switchModule"
                   :ref="component_id"></component>
    </div>
</template>

<script>
    import detailView from "./detail"
    import statisticsView from "./statistics"
    import exportStatView from "./export_stat"
    import {mapState, mapMutations} from "vuex"

    export default {
        name: "",
        components: {
            detailView,
            statisticsView,
            exportStatView
        },
        data() {
            return {

            }
        },
        computed: {
            ...mapState('comInformationData', {
                component_id: 'component_id'
            })
        },
        methods: {
            switchModule(id) {

            }
        }
    }
</script>

<style scoped lang="scss">
    .context {
        width: 100%;
        height: 100%;
    }
</style>